import { ReactNode } from 'react';
import * as styles from './Main.module.scss';

const Main = ({ children }: { children: ReactNode }) => <main className={styles.container}>{children}</main>;

export default Main;
